<template>
  <v-item-group
    v-model="slider"
    mandatory
    active-class="primary--text"
  >
    <v-item
      v-for="category in categories"
      :key="category.id"
      v-slot="{ active, toggle }"
    >
      <v-btn
        :input-value="active"
        icon
        small
        @click="toggle"
      >
        <v-icon
          small
          v-text="category.failed && ! fastEntry ? icons.warning : icons.dot"
        />
      </v-btn>
    </v-item>
  </v-item-group>
</template>

<script>
  import Configurable from '@/Mixins/Configurable'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      Configurable,
      UsesIcons,
    ],

    computed: {
      fastEntry () {
        return this.config('fastMenuEntry')
      },
      slide () {
        return this.fastEntry ? 'dishOrder' : 'category'
      },
      slider: {
        get () {
          return this.$store.state.orders.menu[this.slide]
        },
        set (v) {
          this.$store.commit(`orders/menu/${this.slide}`, v)
        },
      },
      categories () {
        return this.$store.state.orders.menu.categories
      },
    },
  }
</script>
